import React from 'react'
import styled from '~/app/components/styled'
import { Typography } from '@yanolja-org/ya-com-core'

// styled components
const Container = styled.div`
  border: solid 0.1rem ${({ theme }) => theme.color.gray200};
  border-radius: 0.4rem;
  background: ${({ theme }) => theme.color.white};
  position: relative;
  z-index: 0;
  overflow: hidden;
  padding: 1.6rem;
  margin: 1rem 1rem 2rem;

  & p {
    ${Typography('body1.multiline').regular};
    color: ${({ theme }) => theme.color.gray900};
  }
`

type BorderBox = {
  text: string[] | string
} & React.HTMLAttributes<HTMLDivElement>

const BorderBox: React.FunctionComponent<BorderBox> = function ({ text, style }) {
  return (
    <Container style={style}>
      {Array.isArray(text) ? text.map((text, index) => <p key={index}>{text}</p>) : <p>{text}</p>}
    </Container>
  )
}

export default BorderBox
